// namingHelpers.js (or inline in your BuyPassModal)
export function getTitleString(selectedOption, quantity) {
    // For the h2 modal title, e.g. "Buy 2 Day Passes (2× Single Day Passes)"
    // or "Buy 1 Five Day Pass (5 total passes)"
    // or "Buy 3 Monthly Passes (3× Monthly Pass)"
    if (selectedOption === 'Single Day Pass') {
      if (quantity === 1) {
        return `Buy 1 Single Day Pass (1× Single Day Pass)`;
      }
      return `Buy ${quantity} Single Day Passes (${quantity}× Single Day Passes)`;
    }
  
    if (selectedOption === 'Five Day Passes') {
      const total = quantity * 5;
      if (quantity === 1) {
        return `Buy 1 Five Day Pass (5 total passes)`;
      }
      return `Buy ${quantity} Five Day Passes (${total} total passes)`;
    }
  
    if (selectedOption === 'Monthly Pass') {
      if (quantity === 1) {
        return `Buy 1 Monthly Pass (1× Monthly Pass)`;
      }
      return `Buy ${quantity} Monthly Passes (${quantity}× Monthly Pass)`;
    }
  
    // fallback
    return `Buy ${quantity} Passes`;
  }
  
  // For StepThreeCheckout’s text: "You’re about to buy 2 Day Passes (2x Single Day Passes) ..."
  export function getCheckoutDescription(selectedOption, quantity, makeRecurring) {
    let description = '';
    if (selectedOption === 'Single Day Pass') {
      if (quantity === 1) {
        description = `1 Single Day Pass (1× Single Day Pass)`;
      } else {
        description = `${quantity} Single Day Passes (${quantity}× Single Day Passes)`;
      }
    } else if (selectedOption === 'Five Day Passes') {
      const total = quantity * 5;
      if (quantity === 1) {
        description = `1 Five Day Pass (5 total passes)`;
      } else {
        description = `${quantity} Five Day Passes (${total} total passes)`;
      }
    } else if (selectedOption === 'Monthly Pass') {
      if (quantity === 1) {
        description = `1 Monthly Pass (1× Monthly Pass)`;
      } else {
        description = `${quantity} Monthly Passes (${quantity}× Monthly Pass)`;
      }
    }
  
    if (makeRecurring && selectedOption === 'Monthly Pass') {
      // e.g. " (Recurring)" or something
      description += ' (Recurring)';
    }
  
    return description;
  }
  